import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import Modal from "react-modal";
import { Collapse } from "antd";
import moment from "moment";

const { Panel } = Collapse;

const FarmerInspectionForm = (props) => {
  const frmRef = useRef({});

  const [employeeData, setEmployeeData] = useState([]);
  const [employeeId, setEmployeeId] = useState();
  const [farmerId, setFarmerId] = useState("");
  const [farmerListData, setFarmerListData] = useState([]);
  const [plotId, setPlotId] = useState();
  const [plotData, setPlotData] = useState([]);
  const [cropId, setCropId] = useState();
  const [varietyData, setVarietyData] = useState([]);
  const [data, setData] = useState();
  const [justifications, setJustifications] = useState([]);
  const [inspectionDetails, setInspectionDetails] = useState([]);
  const [inspectionJson, setInspectionJson] = useState("");

  const [activitiesCarriedOutByFarmer, setActivitiesCarriedOutByFarmer] =
    useState("");
  const activities = [
    "Planting",
    "Irrigation",
    "Fertilizer Application",
    "Agro Chemical Application",
  ];

  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);
    //console.log(uniqueID);
    return uniqueID.toString();
  }
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [dateOfGabPlanting, setDateOfGabPlanting] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleGabDateChange = (e) => {
    setDateOfGabPlanting(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeByUsecase/?orgId=${localStorage.getItem(
          "orgId"
        )}&useCase=Procurement`,
      },
      (data) => {
        // console.log(data);
        var emplist = data.output;

        setEmployeeData(emplist);
      }
    );
  }, []);

  const { sendRequest: getFarmers } = useHttp();

  useEffect(() => {
    if (employeeId) {
      getFarmers(
        {
          url: `/api/getfarmerDetail/?fieldExecutiveId=${employeeId}`,
        },
        (data) => {
          //  //console.log(data);
          setFarmerListData(data.output);
        }
      );
    }
  }, [employeeId]);

  const { sendRequest: getPlot } = useHttp();

  useEffect(() => {
    if (farmerId) {
      getPlot(
        {
          url: `/api/getfarmerPlotDetail/?orgId=${localStorage.getItem(
            "orgId"
          )}&farmerId=${farmerId}`,
        },
        (data) => {
          // //console.log(data);
          setPlotData(data.output);
        }
      );
    }
  }, [farmerId]);

  const { sendRequest: getVariety } = useHttp();

  useEffect(() => {
    if (plotId) {
      getVariety(
        {
          url: `/api/getfarmerCropPlotDetail/?orgId=${localStorage.getItem(
            "orgId"
          )}&plotId=${plotId}`,
        },
        (data) => {
          // //console.log(data);
          setVarietyData(data.output);
        }
      );
    }
  }, [plotId]);

  const { sendRequest: getComplianceHead } = useHttp();

  const getAllData = () => {
    getComplianceHead(
      {
        url: `/api/getSCHeadView/?orgId=${localStorage.getItem(
          "orgId"
        )}&serviceId=3`,
      },
      (res) => {
        // console.log("compliance",res);
        if (!props.update) {
          setData(res);
        }
      }
    );
  };

  useEffect(() => {
    getAllData();
  }, []);

  const handleJustificationChange = (parentIndex, itemIndex, justification) => {
    const updatedData = [...data];
    const updatedJustifications = [...justifications];

    updatedJustifications[itemIndex] = {
      justification,
    };
    setJustifications("updatedJustifications",updatedJustifications);

    updatedData[parentIndex].serviceWiseComplianceHeadList[itemIndex] = {
      ...updatedData[parentIndex].serviceWiseComplianceHeadList[itemIndex],

      justification: updatedJustifications[itemIndex].justification,
      observation: inspectionDetails[itemIndex].observation,
    };

    console.log(updatedData);

    setInspectionJson(updatedData);
  };

  useEffect(() => {}, [inspectionDetails, justifications]);

  const handleTextboxChange = (parentIndex, itemIndex, observation) => {
    const updatedInspectionDetails = [...inspectionDetails];
    updatedInspectionDetails[itemIndex] = {
      observation,
    };
    //console.log(updatedInspectionDetails);
    setInspectionDetails(updatedInspectionDetails);

    const updatedData = [...data];
    console.log("justifications",justifications);

    updatedData[parentIndex].serviceWiseComplianceHeadList[itemIndex] = {
      ...updatedData[parentIndex].serviceWiseComplianceHeadList[itemIndex],
      justification: justifications[itemIndex].justification,
      observation: updatedInspectionDetails[itemIndex].observation,
    };
    //console.log(updatedData);

    setInspectionJson(updatedData);
  };

  const handleRadioButtonChange = (parentIndex, itemIndex, selectedOption) => {
    const updatedInspectionDetails = [...inspectionDetails];
    updatedInspectionDetails[itemIndex] = {
      observation: selectedOption,
    };
    setInspectionDetails(updatedInspectionDetails);
    // console.log(updatedInspectionDetails);

    const updatedData = [...data];

    updatedData[parentIndex].serviceWiseComplianceHeadList[itemIndex] = {
      ...updatedData[parentIndex].serviceWiseComplianceHeadList[itemIndex],
      justification: justifications[itemIndex].justification,
      observation: updatedInspectionDetails[itemIndex].observation,
    };
    //console.log(updatedData);

    setInspectionJson(updatedData);
  };

  const [uploadedFiles, setUploadedFiles] = useState("");
    const attachmentFolder=localStorage.getItem("attachmentFolder");
  const handleAttachmentChange = (e) => {
    const files = e.target.files;

    const picDataArray = Array.from(files).map((file) => {
      const uniqueFilename = `${new Date().valueOf()}/${file.name}`;
      const picData = new FormData();
      picData.append("fileUpload", file, uniqueFilename);
      return picData;
    });

    const uploadedFilesData = [];

    Promise.all(
      picDataArray.map((picData) =>
        fetch(
          `${
            process.env.REACT_APP_BASE_URL
          }/api/file/${attachmentFolder}/farminspection/${new Date().valueOf()}}`,
          {
            method: "POST",
            body: picData,
          }
        )
          .then((res) => res.json())
          .then((data) => {
            uploadedFilesData.push(data.url);
          })
      )
    )
      .then(() => {
        setUploadedFiles([...uploadedFiles, ...uploadedFilesData]);
      })
      .catch((err) => console.error(err));
  };

  const [uploadedSignature, setUploadedSignature] = useState("");

  const handleSignatureChange = (e) => {
    const picData = new FormData();
    const file = e.target.files[0];
    picData.append("fileUpload", file, file.name);
    fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/file/${attachmentFolder}/internalInspectionSign/${new Date().valueOf()}/${
        file.name
      }`,
      {
        method: "POST",
        body: picData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setUploadedSignature(data.url);
      })
      .catch((err) => console.error(err));
  };

  const { sendRequest: postFarmInspect } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const transformedData = [];
    //console.log(inspectionJson);

    inspectionJson &&
      inspectionJson.forEach((item) => {
        item.serviceWiseComplianceHeadList.forEach((complianceItem) => {
          transformedData.push({
            farmInspectionDetailId: generateUniqueID(),
            createdDate: item.createdDate,
            swcHeadListId: complianceItem.swcHeadListId,
            observation: complianceItem.observation || "",
            justification: complianceItem.justification || "",
            createdBy: parseInt(localStorage.getItem("id")),
          });
        });
      });

    //console.log(transformedData);

    const input = {
      farmInspection: [
        {
          farmInspectionId: generateUniqueID(),
          farmInspectionDate: moment(frmRef.current.date.value).format(
            "DD/MM/YYYY"
          ),
          // inspectionType: frmRef.current.inspection_type.value,
          // researchOrganization: frmRef.current.research_org.value,
          // inspectorName: frmRef.current.inspector_name.value,
          // inspectorMobileNo: frmRef.current.mob_no.value,
          // inspectorEmailId: frmRef.current.email.value,
          farmInspectionDetail: transformedData,
          cropId: cropId,
          otherRecommendationsComments: frmRef.current.other_recom.value,
          farmersRemark: frmRef.current.farmersRemark.value,
          dateOfGabPlanting: frmRef.current.dateOfGabPlanting.value,
          activitiesCarriedOutByFarmer: activitiesCarriedOutByFarmer,
          // inspectStatus: frmRef.current.inspect_status.value,
          // icsType: frmRef.current.ics_type.value,
          fileAttachment: uploadedFiles,
          signatureAttachment: uploadedSignature,
          createdDate: moment(new Date().toISOString()).format(
            "DD/MM/YYYY hh:mm:ss"
          ),
        },
      ],
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: parseInt(localStorage.getItem("orgId")),
    };

    console.log(input);

    postFarmInspect(
      {
        url: "/api/farmInspection/",
        method: props.update ? "PUT" : "POST",
        body: input, //props.update ? input2 :
      },
      (data) => {
        //console.log(data);

        toast.success(
          `Farm Inspection Data ${
            props.update ? "Updated" : "Added Successfully"
          }`
        );
        props.addForm(false);
      }
    );
  };

  const { sendRequest: getFarmInspection } = useHttp();

  useEffect(() => {
    if (props.update) {
      //console.log(props.update);
      const Id = props.update.farmInspectionId || 0;
      //console.log(Id);
      frmRef.current.date.value =
        props.update && props.update.farmInspectionDate;

      const parts =
        props.update.farmInspectionDate &&
        props.update.farmInspectionDate.split("/");
      if (parts.length === 3) {
        const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        setSelectedDate(formattedDate);
      }
      getFarmInspection(
        {
          url: `/api/farmInspection/?orgId=${localStorage.getItem(
            "orgId"
          )}&farmInspectionId=${Id}&editData=edit`,
        },
        (data) => {
          console.log("farmInspection", data);
          const inspection = data.farmInspection;
          setEmployeeId(
            data.farmInspection && data.farmInspection.fieldExecutiveId
          );
          setFarmerId(data.farmInspection && data.farmInspection.farmerId);
          setPlotId(data.farmInspection && data.farmInspection.farmerPlotId);
          setCropId(data.farmInspection && data.farmInspection.cropId);
          // frmRef.current.research_org.value =
          //   data.farmInspection && data.farmInspection.researchOrganization;
          // frmRef.current.inspector_name.value =
          //   data.farmInspection && data.farmInspection.inspectorName;
          // frmRef.current.mob_no.value =
          //   data.farmInspection && data.farmInspection.inspectorMobileNo;
          // frmRef.current.email.value =
          //   data.farmInspection && data.farmInspection.inspectorEmailId;
          frmRef.current.farmersRemark.value =
            data.farmInspection && data.farmInspection.farmersRemark;
          // frmRef.current.inspection_type.value =
          //   data.farmInspection && data.farmInspection.inspectionType;
          // frmRef.current.inspect_status.value =
          //   data.farmInspection && data.farmInspection.inspectStatus;
          // frmRef.current.ics_type.value =
          //   data.farmInspection && data.farmInspection.icsType;
          frmRef.current.other_recom.value =
            data.farmInspection &&
            data.farmInspection.otherRecommendationsComments;
          const dateOfGabPlanting =
            props.update.dateOfGabPlanting.split(" ")[0];
          const [day, month, year] = dateOfGabPlanting.split("/");
          const formattedDate = `${year}-${month}-${day}`;
          setDateOfGabPlanting(formattedDate);
          setActivitiesCarriedOutByFarmer(
            props.update.activitiesCarriedOutByFarmer
          );

          setUploadedFiles(
            data.farmInspection && data.farmInspection.fileAttachment
          );
          setUploadedSignature(
            data.farmInspection && data.farmInspection.signatureAttachment
          );
          setData(
            data.farmInspection &&
              data.farmInspection.serviceWiseComplianceHeadList
          );

          // Map through the data to set observations and justifications
          const updatedData = inspection.serviceWiseComplianceHeadList.map(
            (parent) => ({
              ...parent,
              serviceWiseComplianceHeadList:
                parent.serviceWiseComplianceHeadList.map((item, index) => ({
                  ...item,
                  observation:
                    props.update.serviceWiseComplianceHeadList[index]
                      ?.observation || "",
                  justification:
                    props.update.serviceWiseComplianceHeadList[index]
                      ?.justification || "",
                })),
            })
          );

          setData(updatedData);
        }
      );
    }
  }, [props.update]);
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Farmer Inspcection Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"executive_name"}>
                        {"Field Executive"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        required
                        disabled
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option key={x.userId} value={x.userId}>
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"farmer_name"}>{"Farmer Name"}</label>
                      <select
                        id="farmerId"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["farmer_name"] = el)}
                        value={farmerId}
                        required
                        disabled
                        onChange={(e) => {
                          setFarmerId(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {farmerListData &&
                          farmerListData.map((x) => (
                            <option key={x.farmerId} value={x.farmerId}>
                              {x.farmerName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"plot_name"}>{"Plot Name"}</label>

                      <select
                        id="plot_name"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["plot_name"] = el)}
                        required
                        disabled
                        value={plotId}
                        onChange={(e) => {
                          setPlotId(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {plotData &&
                          plotData.map((x) => (
                            <option key={x.plotId} value={x.plotId}>
                              {x.plotName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"crop_variety"}>{"Crop Variety"}</label>
                      <select
                        id="crop_variety"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["crop_variety"] = el)}
                        value={cropId}
                        required
                        disabled
                        onChange={(e) => {
                          setCropId(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {varietyData &&
                          varietyData.map((x) => (
                            <option key={x.cropId} value={x.cropId}>
                              {x.cropVariety}
                            </option>
                          ))}
                      </select>
                    </div>
                    {/* <div className="col-md-3">
                      <label htmlFor={"inspection_type"}>
                        {"Inspection Type"}
                      </label>
                      <select
                        id="inspection_type"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["inspection_type"] = el)}
                        required
                      >
                        <option value="">Select</option>

                        <option value="Self-assessment">Self-assessment</option>
                        <option value="Chosen certification body">
                          Chosen certification body
                        </option>
                      </select>
                    </div> */}
                    {/* <div className="col-md-3">
                      <label htmlFor={"research_org"}>
                        {"Research Organization"}
                      </label>
                      <input
                        type={"text"}
                        id={"research_org"}
                        required
                        ref={(el) => (frmRef.current["research_org"] = el)}
                        className="form-control"
                      />
                    </div> */}
                    {/* <div className="col-md-3">
                      <label htmlFor={"inspector_name"}>
                        {"Inspector Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"inspector_name"}
                        required
                        ref={(el) => (frmRef.current["inspector_name"] = el)}
                        className="form-control"
                      />
                    </div> */}
                    {/* <div className="col-md-3">
                      <label htmlFor={"mob_no"}>{"Inspector Mobile No"}</label>
                      <input
                        type={"text"}
                        id={"mob_no"}
                        required
                        ref={(el) => (frmRef.current["mob_no"] = el)}
                        className="form-control"
                      />
                    </div> */}
                    {/* <div className="col-md-3">
                      <label htmlFor={"mob_no"}>{"Inspector EmailId"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                      />
                    </div> */}
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Activities carried out by the farmer during the visit
                        </label>
                        <select
                          id="activitiesCarriedOutByFarmer"
                          className="form-control"
                          required
                          value={activitiesCarriedOutByFarmer}
                          onChange={(e) => {
                            setActivitiesCarriedOutByFarmer(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {activities.map((activity, index) => (
                            <option key={index} value={activity}>
                              {activity}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Date of Gab Planting"}</label>
                      <input
                        type={"date"}
                        id={"dateOfGabPlanting"}
                        required
                        ref={(el) => (frmRef.current["dateOfGabPlanting"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={dateOfGabPlanting}
                        onChange={handleGabDateChange}
                      />
                    </div>
                  </div>
                  <div>
                    <br />
                    {data &&
                      data.map((parent, parentIndex) => (
                        <>
                          <Collapse key={parentIndex}>
                            <Panel header={parent.complianceHeadName}>
                              {parent.serviceWiseComplianceHeadList.map(
                                (item, itemIndex) => (
                                  <div key={itemIndex}>
                                    <b>{item.complianceFieldName}</b> <br />
                                    <br />
                                    {item.controlType === "RadioButton" ? (
                                      <>
                                        <label>Observation:</label>
                                        {item.itemList &&
                                          item.itemList.map((option, ii) => (
                                            <label key={ii}>
                                              <input
                                                type="radio"
                                                name={`radio_${parentIndex}_${itemIndex}`}
                                                value={option}
                                                checked={
                                                  item.observation === option
                                                }
                                                onChange={(e) =>
                                                  handleRadioButtonChange(
                                                    parentIndex,
                                                    itemIndex,
                                                    e.target.value
                                                  )
                                                }
                                              />
                                              {option}
                                            </label>
                                          ))}
                                      </>
                                    ) : item.controlType === "TextBox" ? (
                                      <>
                                        <label>Observation:</label>
                                        <input
                                          type="text"
                                          value={item.observation}
                                          onChange={(e) =>
                                            handleTextboxChange(
                                              parentIndex,
                                              itemIndex,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </>
                                    ) : null}
                                    <br />
                                    <div>
                                      <label>Justification:</label>
                                      <input
                                        type="text"
                                        value={item.justification}
                                        onChange={(e) =>
                                          handleJustificationChange(
                                            parentIndex,
                                            itemIndex,
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                    <br />
                                  </div>
                                )
                              )}
                            </Panel>
                          </Collapse>
                          <br />
                        </>
                      ))}
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"farmersRemark"}>
                        {"Farmer's Remark"}
                      </label>
                      <input
                        type={"text"}
                        id={"farmersRemark"}
                        required
                        ref={(el) => (frmRef.current["farmersRemark"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"other_recom"}>
                        {"Other Recommendations"}
                      </label>
                      <input
                        type={"text"}
                        id={"other_recom"}
                        required
                        ref={(el) => (frmRef.current["other_recom"] = el)}
                        className="form-control"
                      />
                    </div>
                    {/* <div className="col-md-3">
                      <label htmlFor={"inspect_status"}>
                        {"Inspect Status"}
                      </label>
                      <select
                        id="inspect_status"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["inspect_status"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        <option value="true">Approved</option>
                        <option value="false">Denied</option>
                      </select>
                    </div> */}
                    {/* <div className="col-md-3">
                      <label htmlFor={"ics_type"}>{"ICS Type"}</label>
                      <select
                        id="ics_type"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["ics_type"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        <option value="IC-1">IC-1</option>
                        <option value="IC-2">IC-2</option>
                        <option value="IC-3">IC-3</option>
                        <option value="Organic">Organic</option>
                        <option value="Fair For Life Fair Trade">
                          Fair For Life Fair Trade{" "}
                        </option>
                        <option value="GlobalGAP">GlobalGAP</option>
                      </select>
                    </div> */}
                    <div className="col-md-3">
                      <label htmlFor={"Attachment"}>{"Attachment"}</label>
                      <label className="custom-file-upload">
                        <input
                          type="file"
                          id={"attachment"}
                          ref={(el) => (frmRef.current["attachment"] = el)}
                          className="form-control"
                          multiple
                          onChange={handleAttachmentChange}
                        />
                      </label>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Signature"}>{"Signature"}</label>
                      <label className="custom-file-upload">
                        <input
                          type="file"
                          id={"signature"}
                          ref={(el) => (frmRef.current["signature"] = el)}
                          className="form-control"
                          onChange={handleSignatureChange}
                        />
                      </label>
                    </div>
                  </div>
                  <div className=" text-center">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerInspectionForm;
